import React from "react";
import Utils from "Utils/utils";
import MemberBreakdownSkeleton from "./MemberBreakdownSkeleton";

const MemberBreakdownList = ({ rows, loading, mode = "count" }) => {
  if (loading) return <MemberBreakdownSkeleton />;
  if (!rows?.length) return null;
  const isRate = mode === "rate";
  const total = isRate ? 0 : rows.reduce((sum, r) => sum + (r.count || 0), 0);
  return (
    <div className="widgetCardMemberBreakdown">
      {rows.map(r => {
        const pct = isRate
          ? Math.min(100, Math.max(0, Math.round(r.rate || 0)))
          : total > 0
          ? Math.min(100, Math.round(((r.count || 0) / total) * 100))
          : 0;
        const valueLabel = isRate ? `${(r.rate || 0).toFixed(1)}%` : Utils.formatNumberToStringInUSFormat(r.count);
        return (
          <div key={r.memberId} className="widgetCardMemberBreakdownRow">
            <div className="widgetCardMemberBreakdownHeader">
              <span className="widgetCardMemberBreakdownName">{r.name || r.memberId}</span>
              <span className="widgetCardMemberBreakdownValue">
                {valueLabel}
                {isRate && r.denominator != null && (
                  <span className="widgetCardMemberBreakdownSub"> · {Utils.formatNumberToStringInUSFormat(r.numerator)}/{Utils.formatNumberToStringInUSFormat(r.denominator)}</span>
                )}
              </span>
            </div>
            <div className="widgetCardMemberBreakdownBarTrack">
              <div className="widgetCardMemberBreakdownBarFill" style={{ width: `${pct}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MemberBreakdownList;
